import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import SecureLS from "secure-ls";
import StoreTitle from "../../component/StoreTitle";

const ls = new SecureLS({ encodingType: "aes" });

const NotifHero = ({ title = "Notification Center" }) => {
  const navigate = useNavigate();
  const user = ls.get("user");
  const role = user?.role || "";

  return (
    <Box sx={{ padding: 3 }}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/dashboard")}
        sx={{ marginBottom: 3 }}
      >
        Back
      </Button>
      <Box sx={{ marginTop: -8 }}>
        <StoreTitle title={title} />
      </Box>
    </Box>
  );
};

export default NotifHero;
